import { AlertTriangle } from "lucide-react"
import type { ReactNode } from "react"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { getErrorReferenceId, getUserErrorMessage } from "@/lib/errors"

export function ErrorReference({ error }: { error: unknown }) {
  const requestId = getErrorReferenceId(error)
  if (!requestId) return null

  return (
    <span className="mt-2 block font-mono text-xs text-muted-foreground">
      Reference: {requestId}
    </span>
  )
}

export function UserErrorAlert({
  error,
  prefix,
  variant = "default",
}: {
  error: unknown
  prefix?: string
  variant?: "default" | "destructive"
}) {
  const message = getUserErrorMessage(error)

  return (
    <Alert variant={variant}>
      <AlertTriangle />
      <AlertDescription>
        {prefix ? `${prefix} ${message}` : message}
        <ErrorReference error={error} />
      </AlertDescription>
    </Alert>
  )
}

export function UserErrorText({
  error,
  prefix,
}: {
  error: unknown
  prefix?: string
}): ReactNode {
  const message = getUserErrorMessage(error)
  return prefix ? `${prefix} ${message}` : message
}
